const getEnv = (key, fallback = "") => {
    return process.env[key] || fallback;
};

export const appConfig = Object.freeze({
    baseUrlMasbar: getEnv("VUE_APP_BASE_URL_MASBAR"),
    baseUrlReceiving: getEnv("VUE_APP_BASE_URL_RECEIVING"),
    baseUrlSecond: getEnv("VUE_APP_BASE_URL_SECOND"),
    baseUrl: getEnv("VUE_APP_BASE_URL"),
    paymentUrl: getEnv("VUE_APP_PAYMENT_URL"),
    baseUrlPo: getEnv("VUE_APP_BASE_URL_PO"),
    holdingUrl: getEnv("VUE_APP_HOLDING_URL"),
    feUrl: getEnv("VUE_APP_FE_URL"),
    bff: getEnv("VUE_APP_BFF_URL"),
    goScaleUrl: getEnv("VUE_APP_GO_SCALE_URL"),
});